// vendors
import LazyLoad from "vanilla-lazyload"

var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
});


window.lazyFunctions = {
    spinner: function (element) {
        element.parentElement.classList.add('no-spinner');      
    }
};

function removeSpinner(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-function");
    var lazyFunction = window.lazyFunctions[lazyFunctionName]; 
    if (!lazyFunction) return;
    lazyFunction(element);
}

var ll = new LazyLoad({
    unobserve_entered: true, // <- Avoid executing the function multiple times
    callback_enter: removeSpinner // Assigning the function defined above
});